import { IntlShape, defineMessages } from 'react-intl'
import * as yup from 'yup'

import { ICreateRoutingProjectPlanForm } from 'features/RoutingProjects/types'
import { getSchemaAssociations } from 'utils/schema'

const nameMessages = defineMessages({
  required: {
    id: 'routingProjects.create.plan.name.required',
    defaultMessage: 'The plan name is required'
  },
  min: {
    id: 'routingProjects.create.plan.name.min',
    defaultMessage: 'The plan name must be at least {min} characters'
  }
})

const datasetMessages = defineMessages({
  required: {
    id: 'routingProjects.create.plan.dataset.required',
    defaultMessage: 'You need to select an existing dataset or upload a new one'
  },
  nameRequired: {
    id: 'routingProjects.create.plan.dataset.name.required',
    defaultMessage: 'The dataset name is required'
  }
})

export const schema = (intl: IntlShape): yup.SchemaOf<ICreateRoutingProjectPlanForm> => {
  return yup.object().shape(
    {
      name: yup
        .string()
        .required(intl.formatMessage(nameMessages.required))
        .min(2, ({ min }) => intl.formatMessage(nameMessages.min, { min })),
      dataset: yup
        .object()
        .shape({
          id: yup.string(),
          name: yup.string().required(intl.formatMessage(datasetMessages.nameRequired))
        })
        .when('file', {
          is: (file: ICreateRoutingProjectPlanForm['file']) => !file,
          then: yup.object().shape({
            id: yup.string().required(intl.formatMessage(datasetMessages.required)),
            name: yup.string()
          })
        }),
      file: yup.mixed().when('dataset', {
        is: (dataset: ICreateRoutingProjectPlanForm['dataset']) => !dataset,
        then: yup.mixed().required(intl.formatMessage(datasetMessages.required))
      })
    },
    getSchemaAssociations(['file', 'dataset'])
  )
}
